export default "__VITE_ASSET__0ad9408c__"